import './AboutUs.css'
import { Container } from '@material-ui/core'
import HeroComponent from '../../components/HeroComponent/HeroComponent'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import Typography from '@mui/material/Typography'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { getAbout, updateAbout } from '../../entity/about/model/slice/aboutSlice'
import { getAboutData } from '../../entity/about/About'
import { useEffect } from 'react'
import MembersList from './Components/MembersList'
import { getUserData } from '../../entity/user/model/selector/getUserData/getUserData'
import { MdOutlineModeEdit } from 'react-icons/md'
import { useState } from 'react'
import EditAboutModal from '../../components/EditAboutModal/EditAboutModal'

const AboutUs = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAbout())
  }, [dispatch])

  const user = useSelector(getUserData, shallowEqual)
  const about = useSelector(getAboutData, shallowEqual)

  const [isOpen, setIsOpen] = useState(false)

  const modalHandler = () => {
    setIsOpen(prev => !prev)
  }

  const onEditAboutSubmit = async value => {
    console.log('value: ', value)
    if (!value?.content_en || !value?.content_ka) {
      alert('Both English and Georgian content are required.')
      return
    }

    try {
      await dispatch(updateAbout({ data: value }))
      await dispatch(getAbout())
      modalHandler()
    } catch (error) {
      console.error('Error updating current issue:', error)
    }
  }

  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <title>{t('Aboutus.title')}</title>
        <meta
          name='description'
          content="Learn about Moambe - Georgia's leading scientific journal. Meet our editorial board, council members and discover our mission in advancing academic research."
        />
        <meta
          name='keywords'
          content='moambe journal, georgian scientific journal, editorial board, academic council, research publication, მოამბე ჟურნალი'
        />
        <meta name='author' content='Moambe Journal' />
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />

        {/* Open Graph / Facebook */}
        <meta property='og:type' content='website' />
        <meta property='og:url' content='http://moambe.org.ge/about' />
        <meta property='og:title' content={t('Aboutus.title')} />
        <meta
          property='og:description'
          content="Learn about Moambe - Georgia's leading scientific journal. Meet our editorial board, council members and discover our mission in advancing academic research."
        />
        <meta property='og:image' content='http://moambe.org.ge/og-image.jpg' />

        {/* Twitter */}
        <meta property='twitter:card' content='summary_large_image' />
        <meta property='twitter:url' content='http://moambe.org.ge/about' />
        <meta property='twitter:title' content={t('Aboutus.title')} />
        <meta
          property='twitter:description'
          content="Learn about Moambe - Georgia's leading scientific journal. Meet our editorial board, council members and discover our mission in advancing academic research."
        />
        <meta property='twitter:image' content='http://moambe.org.ge/og-image.jpg' />

        {/* Canonical URL */}
        <link rel='canonical' href='http://moambe.org.ge/about' />

        {/* Language */}
        <meta property='og:locale' content='en_US' />
        <meta property='og:locale:alternate' content='ka_GE' />
      </Helmet>
      <HeroComponent />
      <div className='about-us'>
        <Container>
          <div className='about-us-content'>
            <div className='archive-title relative' style={{ marginTop: '50px' }}>
              <div className='border-contact-home' />
              <h4>{t('Aboutus.title')}</h4>
              {user?.role === 'admin' && (
                <MdOutlineModeEdit
                  className='my-2 text-4xl hover:scale-110 transition-all cursor-pointer text-[#326383] absolute top-0 right-32 border-2 border-[#326383] rounded-full p-1 bg-slate-100'
                  onClick={modalHandler}
                />
              )}
              <div className='border-contact-home' />
            </div>
            <div className='about-us-content-main'>
              {about?.id && (
                <Typography
                  align='justify'
                  style={{ textIndent: '20px', fontSize: '14px' }}
                  className='whitespace-pre-line'
                >
                  {i18n.language === 'ka' ? about?.content_ka : about?.content_en}
                </Typography>
              )}
              <div className='about-moambe-members'>
                <MembersList />
              </div>
            </div>
          </div>
        </Container>
      </div>
      <EditAboutModal
        isOpen={isOpen}
        onClose={modalHandler}
        data={about}
        onSubmit={onEditAboutSubmit}
      />
    </>
  )
}

export default AboutUs
